class GiftWrappingComponent extends HTMLElement {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("m-cart-drawer");
    this.giftWrapId = this.dataset.giftWrapId;
    this.giftWrapping = this.dataset.giftWrapping;
    this.giftWrapsInCart = parseInt(this.getAttribute("gift-wraps-in-cart"));
    this.loadingIcon = this.querySelector(".m-gift-wrapping--loading");
    this.cart = document.querySelector("m-cart-drawer");
    
    // Listen for checkbox changes
    this.querySelector('[name="attributes[gift-wrapping]"]').addEventListener("change", (event) => {
      event.preventDefault();
      event.target.checked ? this.setGiftWrapping() : this.removeGiftWrapping();
    });
  }

  setGiftWrapping() {
    if (this.giftWrapsInCart === 0) {
      this.loadingIcon.classList.add("show");

      const requestData = {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Accept: "application/json"
        }),
        body: JSON.stringify({
          updates: { [this.giftWrapId]: 1 },  // Always add only 1 gift wrap
          attributes: { "gift-wrapping": true }
        })
      };

      this.updateCart(requestData);
    }
  }

  removeGiftWrapping() {
    if (this.giftWrapsInCart > 0) {
      this.loadingIcon.classList.add("show");

      const requestData = {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Accept: "application/json"
        }),
        body: JSON.stringify({
          updates: { [this.giftWrapId]: 0 },  // Remove all gift wraps
          attributes: { "gift-wrapping": false, "gift-note": "" }
        })
      };

      this.updateCart(requestData);
    }
  }

  updateCart(requestData) {
    return fetch(`${MinimogSettings.routes.cart_update_url}`, requestData)
      .then((response) => response.json())
      .then((data) => {
        this.loadingIcon.classList.remove("show");
        
        // Only update the cart drawer if available
        if (this.cartDrawer) {
          this.cartDrawer.onCartDrawerUpdate();
          this.cartDrawer.classList.toggle("m-cart--empty", data.item_count === 0);
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, data);
        }
      })
      .catch((error) => {
        console.error("Error updating cart: ", error);
      });
  }
}

customElements.define("m-gift-wrapping-component", GiftWrappingComponent);